import { render, staticRenderFns } from "./commonGoodsThirdClass.vue?vue&type=template&id=1df9c2bf"
import script from "./commonGoodsThirdClass.vue?vue&type=script&lang=ts"
export * from "./commonGoodsThirdClass.vue?vue&type=script&lang=ts"
import style0 from "./commonGoodsThirdClass.vue?vue&type=style&index=0&id=1df9c2bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports